module.exports = "\nvarying vec2 f_uv;\nvarying vec3 f_normal;\nvarying vec3 f_position;\nvarying vec3 f_ray;\n\n// uv, position, projectionMatrix, modelViewMatrix, normal\nvoid main() {\n    f_uv = uv;\n    f_normal = normal;\n    f_position = position;\n    f_ray = f_position - cameraPosition;\n    gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/shaders/bio-vert.glsl
// module id = 13
// module chunks = 0